import { HOME_URL } from "../constant/routes";

export const getFirstUrl = (url: string) => {
  let path = url.split(HOME_URL);
  return path[1];
};
